import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthContainer from "../components/auth/AuthContainer";
import { auth } from "../config/firebase";

const Login = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (auth.currentUser) {
            console.info("User already logged in. Redirecting to home.");
            navigate("/");
        }
    }, [navigate]);

    return (
        <AuthContainer />
    );
};

export default Login;
